// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M7.25 2 H12.75 C13.44 2 14 2.56 14 3.25 V5.25 C14 5.94 13.44 6.5 12.75 6.5 H7.25 C6.56 6.5 6 5.94 6 5.25 V3.25 C6 2.56 6.56 2 7.25 2 Z',
  'M7.25 9.5 H12.75 C13.44 9.5 14 10.06 14 10.75 V12.75 C14 13.44 13.44 14 12.75 14 H7.25 C6.56 14 6 13.44 6 12.75 V10.75 C6 10.06 6.56 9.5 7.25 9.5 Z',
  'M1.5 6L3.5 8L1.5 10',
];
